import { Button, Checkbox, DatePicker, Form, Input, Select, TimePicker } from 'antd';
import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import regex, { NOTIFIES, ACCOUNT_STATUS, USER_TYPE_OPTIONS } from '../../../constants/system.keys';
import { openMessage } from '../../../redux/actions';
import { toHoursAndMinutes } from '../../../untils/date';
import InputTag from '../../../components/InputTag';


const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const { Option } = Select;

const UpdateMemberComponent = ({
  namespace,
  data,
  onUpdate,
  setUserType,
}) => {
  console.log("🚀 ~ UpdateMemberComponent ~ data:", data)
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const { detailRoleOfCustomer } = useSelector(
    (state) => state
  );
  const [, forceUpdate] = useState();
  const [requestId, setRequestId] = useState();



  useEffect(() => {
    forceUpdate({});
    return () => {
      form.resetFields();
    };
  }, [form]);

  useEffect(() => {
    if (namespace && data) {
      const {
        phonenumber,
        namespace,
        fullName,
        email,
        role,
        detailRoles,
        position,
        authMethod,
        enableWatermark,
        accountStatus,
        expireTime,
        username,
        password,
        externalUserId,
        allowIps,
        accountConfiguration,
      } = data;

      let parsedConfig = {};
      if (accountConfiguration) {
        try {
          parsedConfig = typeof accountConfiguration === 'string'
            ? JSON.parse(accountConfiguration)
            : accountConfiguration;
        } catch (e) {
          console.error("Error parsing accountConfiguration:", e);
        }
      }

      const configAllowIps = parsedConfig?.allowIps || (allowIps !== 0 && allowIps ? allowIps : '');

      const dataLiveTimeoutTemp =
        parsedConfig?.liveTimeout >= 0
          ? toHoursAndMinutes(parsedConfig.liveTimeout)
          : null;

      form.setFieldsValue({
        username,
        password,
        authMethod,
        phonenumber,
        namespace,
        fullName,
        email,
        role,
        enableWatermark,
        expireTime: expireTime ? moment(expireTime) : null,
        accountStatus: accountStatus === ACCOUNT_STATUS.ACTIVE,
        detailRoles: detailRoles ? detailRoles?.split(';') : [],
        position: position ?? '',
        liveTimeout: dataLiveTimeoutTemp
          ? moment(
            `${dataLiveTimeoutTemp?.h}:${dataLiveTimeoutTemp?.m}`,
            'HH:mm'
          )
          : null,
        interactionTimeout: parsedConfig?.interactionTimeout ?? 0,
        disableMultiSession: parsedConfig?.disableMultiSession ?? true,
        externalUserId:
          externalUserId === null || externalUserId === undefined
            ? ''
            : String(externalUserId),
        allowIps: configAllowIps
          ? configAllowIps.split(';').filter((ip) => ip.trim() !== '')
          : [],
      });
      setUserType(role);
    }
  }, [data, form, namespace, setUserType]);
  const onFinish = (values) => {
    let current = new Date().getTime();
    setRequestId(current);

    let parsedConfig = {};
    if (data?.accountConfiguration) {
      try {
        parsedConfig = typeof data.accountConfiguration === 'string'
          ? JSON.parse(data.accountConfiguration)
          : data.accountConfiguration;
      } catch (e) { }
    }
    const configAllowIps = parsedConfig?.allowIps || (data?.allowIps !== 0 && data?.allowIps ? data.allowIps : '');
    const initialAllowIps = configAllowIps
      ? configAllowIps.split(';').filter((ip) => ip.trim() !== '')
      : [];
    const currentAllowIps = values.allowIps || [];

    const isArraysEqual = (a, b) => {
      if (a.length !== b.length) return false;
      return a.every((val, index) => val === b[index]);
    };

    const isAllowIpsChanged = !isArraysEqual(initialAllowIps, currentAllowIps);

    const submitValues = {
      ...values,
      externalUserId: values?.externalUserId?.toString().trim() || '',
      accountId: data?.accountId,
      username: data.username,
      disableMultiSession: values.disableMultiSession ? 0 : 1,
    };

    if (!isAllowIpsChanged) {
      delete submitValues.allowIps;
    }

    return onUpdate(current, submitValues);
  };

  const handleChangeUserType = (value) => {
    form.setFieldsValue({ detailRoles: [] });
    setUserType(value);
  };

  return (
    <div className="add-whitelist-ip-component">
      <Form form={form} {...layout} onFinish={onFinish} name="form_in_modal">
        <Form.Item
          name="phonenumber"
          label={t('Phone number')}
          rules={[
            {
              required: data?.phonenumber ? true : false,
              message: t('Please input the phone number!'),
            },
            {
              pattern: regex.isMobile,
              message: t('Please input the phone number!'),
            },
          ]}
        >
          <Input disabled placeholder={t('Phone number')} />
        </Form.Item>

        {/* <>
            <Form.Item
              name="username"
              label={t('Username')}
              rules={[
                {
                  required: true,
                  message: t('Please input the username!'),
                },
                {
                  pattern: regex.isUserNameApi,
                  message: t('Username is not valid!'),
                },
              ]}
            >
              <Input placeholder={t('Username')} />
            </Form.Item>

            <Form.Item
              name="password"
              label={t('Password')}
              rules={[
                {
                  required: true,
                  message: t('Please input the password!'),
                },
                {
                  pattern: regex.isPassword,
                  message: t('Password is not valid!'),   
                },
              ]}
            >
              <Input.Password placeholder={t('Password')} />
            </Form.Item>
          </> */}

        <Form.Item
          name="namespace"
          label={t('Namespace')}
          rules={[
            {
              required: true,
              message: t('Please input the namespace!'),
            },
            {
              pattern: regex.isurl,
              message: t('Please input the namespace!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input disabled placeholder={t('Namespace')} />
        </Form.Item>
        <Form.Item
          name="externalUserId"
          label={t('External Id')}
        >
          <Input placeholder={t('External Id')} />
        </Form.Item>
        <Form.Item
          name="fullName"
          label={t('Full name')}
          rules={[
            {
              required: true,
              message: t('Please input the name of member!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input placeholder={t('Full name')} />
        </Form.Item>
        <Form.Item
          name="email"
          label={t('Email')}
          rules={[
            {
              required: true,
              message: t('Please input the email!'),
            },
            {
              type: 'email',
              message: t('Email address is not valid!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input placeholder={t('Email')} />
        </Form.Item>
        <Form.Item
          name="position"
          label={t('Position')}
          rules={[
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input placeholder={t('Position')} />
        </Form.Item>
        <Form.Item
          name="role"
          label={t('UserType')}
          rules={[
            {
              required: true,
              message: t('Please select the permission of member!'),
            },
          ]}
        >
          <Select
            placeholder={t('Permission of member')}
            onChange={handleChangeUserType}
          >
            {USER_TYPE_OPTIONS.map((item) => (
              <Option value={item.value}>{item.label}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="detailRoles"
          label={t('Role')}
        >
          <Select mode="multiple" placeholder={t('Role of member')}>
            {detailRoleOfCustomer?.map((role) => (
              <Option key={role} value={role}>
                {role?.replaceAll('-', ' ')}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="allowIps"
          label={t('Allowed IPs')}

          rules={[
            {
              validator: (_, value) => {
                if (!value || !Array.isArray(value) || value.length === 0) {
                  return Promise.resolve();
                }
                if (value.length > 5) {
                  return Promise.reject(new Error(t('Maximum of 5 IPs allowed!')));
                }
                const ipv4Regex = /^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                for (const ip of value) {
                  if (!ipv4Regex.test(ip)) {
                    return Promise.reject(new Error(t('Please enter a valid IP address!')));
                  }
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <InputTag numberTag={5} nameAdd={t('Add IP')}
            onlyNumbersAndSpecial={true}
            validateTag={(ip) => {
              const ipv4Regex = /^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
              return ipv4Regex.test(ip);
            }}
            containerStyle={{
              border: '1px solid #434343',
              padding: '4px 8px',
              margin: 0
            }}
          />
        </Form.Item>
        <Form.Item name="liveTimeout" label={t('Live Timeout')}>
          <TimePicker format="HH:mm" showNow={false} allowClear={false} />
        </Form.Item>
        <Form.Item name="interactionTimeout" label={t('Interaction Timeout')}>
          <Input
            placeholder={t('Interaction Timeout')}
            type="number"
            defaultValue={0}
            min={0}
          />
        </Form.Item>
        <Form.Item
          name="disableMultiSession"
          valuePropName="checked"
          label={t('Multi Session')}
        >
          <Checkbox></Checkbox>
        </Form.Item>
        <Form.Item
          label={t('Active Status')}
          name="accountStatus"
          valuePropName="checked">
          <Checkbox />
        </Form.Item>
        <Form.Item
          label={t('Expire Time')}
          name="expireTime">
          <DatePicker showTime />
        </Form.Item>
        <Form.Item
          label={t('Enable Watermark')}
          name="enableWatermark"
          valuePropName="checked">
          <Checkbox />
        </Form.Item>
        <div className="create-btn">
          <Form.Item shouldUpdate={true}>
            <Button type="primary" htmlType="submit">
              {t('Update')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default UpdateMemberComponent;
